import infoComponent from "@/components/bootcamp/enroll/meta/TheBootcampMeta"
import howItWorksComponent from "@/components/bootcamp/enroll/how-it-works/TheHowItWorksSection"
import introComponent from "@/components/bootcamp/enroll/intro/TheBootcampIntro"
import previewComponent from "@/components/bootcamp/enroll/preview/TheBootcampPreview"
import coachComponent from "@/components/bootcamp/enroll/coach/TheBootcampCoach"
import afterBootcampComponent from "@/components/bootcamp/enroll/after/TheAfterBootcamp"
import overviewComponent from "@/components/bootcamp/enroll/overview/TheBootcampOverview"
import testimonialsComponent from "@/components/bootcamp/enroll/testimonial/TheBootcampTestimonials"

import zombsHero from "@/assets/images/bootcamp/enroll/hero/zombs.png"
import clixHero from "@/assets/images/bootcamp/enroll/hero/clix.png"
import snip3downHero from "@/assets/images/bootcamp/enroll/hero/snip3down.png"
import benjyfishyHero from "@/assets/images/bootcamp/enroll/hero/benjyfishy.png"
import doubleliftHero from "@/assets/images/bootcamp/enroll/hero/doublelift.png"
import penguHero from "@/assets/images/bootcamp/enroll/hero/pengu.png"

import card1 from "@/assets/images/bootcamp/cards/1.png"
import card2 from "@/assets/images/bootcamp/cards/2.png"
import card3 from "@/assets/images/bootcamp/cards/3.png"
import card4 from "@/assets/images/bootcamp/cards/4.png"
import card5 from "@/assets/images/bootcamp/cards/5.png"
import card6 from "@/assets/images/bootcamp/cards/6.png"
import card7 from "@/assets/images/bootcamp/cards/7.png"
import card8 from "@/assets/images/bootcamp/cards/8.png"
import card9 from "@/assets/images/bootcamp/cards/9.png"
import card10 from "@/assets/images/bootcamp/cards/10.png"
import card11 from "@/assets/images/bootcamp/cards/11.png"
import card12 from "@/assets/images/bootcamp/cards/12.png"
import card13 from "@/assets/images/bootcamp/cards/13.png"
import card14 from "@/assets/images/bootcamp/cards/14.png"
import card15 from "@/assets/images/bootcamp/cards/15.png"
import card16 from "@/assets/images/bootcamp/cards/16.png"
import card17 from "@/assets/images/bootcamp/cards/17.png"
import card18 from "@/assets/images/bootcamp/cards/18.png"

import zombsCard1 from "@/assets/images/bootcamp/cards/zombs/1.png"
import zombsCard2 from "@/assets/images/bootcamp/cards/zombs/2.png"
import zombsCard3 from "@/assets/images/bootcamp/cards/zombs/3.png"
import zombsCard4 from "@/assets/images/bootcamp/cards/zombs/4.png"
import zombsCard5 from "@/assets/images/bootcamp/cards/zombs/5.png"
import zombsCard6 from "@/assets/images/bootcamp/cards/zombs/6.png"
import zombsCard7 from "@/assets/images/bootcamp/cards/zombs/7.png"
import zombsCard8 from "@/assets/images/bootcamp/cards/zombs/8.png"
import zombsCard9 from "@/assets/images/bootcamp/cards/zombs/9.png"
import zombsCard10 from "@/assets/images/bootcamp/cards/zombs/10.png"
import zombsCard11 from "@/assets/images/bootcamp/cards/zombs/11.png"
import zombsCard12 from "@/assets/images/bootcamp/cards/zombs/12.png"

import clixCard1 from "@/assets/images/bootcamp/enroll/cards/clix/1.png"
import clixCard2 from "@/assets/images/bootcamp/enroll/cards/clix/2.png"
import clixCard3 from "@/assets/images/bootcamp/enroll/cards/clix/3.png"
import clixCard4 from "@/assets/images/bootcamp/enroll/cards/clix/4.png"
import clixCard5 from "@/assets/images/bootcamp/enroll/cards/clix/5.png"
import clixCard6 from "@/assets/images/bootcamp/enroll/cards/clix/6.png"
import clixCard7 from "@/assets/images/bootcamp/enroll/cards/clix/7.png"
import clixCard8 from "@/assets/images/bootcamp/enroll/cards/clix/8.png"
import clixCard9 from "@/assets/images/bootcamp/enroll/cards/clix/9.png"
import clixCard10 from "@/assets/images/bootcamp/enroll/cards/clix/10.png"
import clixCard11 from "@/assets/images/bootcamp/enroll/cards/clix/11.png"
import clixCard12 from "@/assets/images/bootcamp/enroll/cards/clix/12.png"

import snip3downIntroCard1 from "@/assets/images/bootcamp/enroll/cards/snip3down/1.png"
import snip3downIntroCard2 from "@/assets/images/bootcamp/enroll/cards/snip3down/2.png"
import snip3downIntroCard3 from "@/assets/images/bootcamp/enroll/cards/snip3down/3.png"
import snip3downIntroCard4 from "@/assets/images/bootcamp/enroll/cards/snip3down/4.png"
import snip3downIntroCard5 from "@/assets/images/bootcamp/enroll/cards/snip3down/5.png"
import snip3downIntroCard6 from "@/assets/images/bootcamp/enroll/cards/snip3down/6.png"
import snip3downIntroCard7 from "@/assets/images/bootcamp/enroll/cards/snip3down/7.png"
import snip3downIntroCard8 from "@/assets/images/bootcamp/enroll/cards/snip3down/8.png"
import snip3downIntroCard9 from "@/assets/images/bootcamp/enroll/cards/snip3down/9.png"
import snip3downIntroCard10 from "@/assets/images/bootcamp/enroll/cards/snip3down/10.png"
import snip3downIntroCard11 from "@/assets/images/bootcamp/enroll/cards/snip3down/11.png"
import snip3downIntroCard12 from "@/assets/images/bootcamp/enroll/cards/snip3down/12.png"

import benjyfishyIntroCard1 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/1.png"
import benjyfishyIntroCard2 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/2.png"
import benjyfishyIntroCard3 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/3.png"
import benjyfishyIntroCard4 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/4.png"
import benjyfishyIntroCard5 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/5.png"
import benjyfishyIntroCard6 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/6.png"
import benjyfishyIntroCard7 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/7.png"
import benjyfishyIntroCard8 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/8.png"
import benjyfishyIntroCard9 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/9.png"
import benjyfishyIntroCard10 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/10.png"
import benjyfishyIntroCard11 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/11.png"
import benjyfishyIntroCard12 from "@/assets/images/bootcamp/enroll/cards/benjyfishy/12.png"

import doubleliftIntroCard1 from "@/assets/images/bootcamp/enroll/cards/doublelift/1.png"
import doubleliftIntroCard2 from "@/assets/images/bootcamp/enroll/cards/doublelift/2.png"
import doubleliftIntroCard3 from "@/assets/images/bootcamp/enroll/cards/doublelift/3.png"
import doubleliftIntroCard4 from "@/assets/images/bootcamp/enroll/cards/doublelift/4.png"
import doubleliftIntroCard5 from "@/assets/images/bootcamp/enroll/cards/doublelift/5.png"
import doubleliftIntroCard6 from "@/assets/images/bootcamp/enroll/cards/doublelift/6.png"
import doubleliftIntroCard7 from "@/assets/images/bootcamp/enroll/cards/doublelift/7.png"
import doubleliftIntroCard8 from "@/assets/images/bootcamp/enroll/cards/doublelift/8.png"
import doubleliftIntroCard9 from "@/assets/images/bootcamp/enroll/cards/doublelift/9.png"
import doubleliftIntroCard10 from "@/assets/images/bootcamp/enroll/cards/doublelift/10.png"
import doubleliftIntroCard11 from "@/assets/images/bootcamp/enroll/cards/doublelift/11.png"
import doubleliftIntroCard12 from "@/assets/images/bootcamp/enroll/cards/doublelift/12.png"

import penguIntroCard1 from "@/assets/images/bootcamp/enroll/cards/pengu/1.png"
import penguIntroCard2 from "@/assets/images/bootcamp/enroll/cards/pengu/2.png"
import penguIntroCard3 from "@/assets/images/bootcamp/enroll/cards/pengu/3.png"
import penguIntroCard4 from "@/assets/images/bootcamp/enroll/cards/pengu/4.png"
import penguIntroCard5 from "@/assets/images/bootcamp/enroll/cards/pengu/5.png"
import penguIntroCard6 from "@/assets/images/bootcamp/enroll/cards/pengu/6.png"
import penguIntroCard7 from "@/assets/images/bootcamp/enroll/cards/pengu/7.png"
import penguIntroCard8 from "@/assets/images/bootcamp/enroll/cards/pengu/8.png"
import penguIntroCard9 from "@/assets/images/bootcamp/enroll/cards/pengu/9.png"
import penguIntroCard10 from "@/assets/images/bootcamp/enroll/cards/pengu/10.png"
import penguIntroCard11 from "@/assets/images/bootcamp/enroll/cards/pengu/11.png"
import penguIntroCard12 from "@/assets/images/bootcamp/enroll/cards/pengu/12.png"

import preview1 from "@/assets/images/bootcamp/preview/preview-1.png"
import preview2 from "@/assets/images/bootcamp/preview/preview-2.png"
import preview3 from "@/assets/images/bootcamp/preview/preview-3.png"
import preview4 from "@/assets/images/bootcamp/preview/preview-4.png"
import preview5 from "@/assets/images/bootcamp/preview/preview-5.png"
import preview6 from "@/assets/images/bootcamp/preview/preview-6.png"
import preview7 from "@/assets/images/bootcamp/preview/preview-7.png"

import zombsPreview1 from "@/assets/images/bootcamp/preview/zombs/preview-1.png"
import zombsPreview2 from "@/assets/images/bootcamp/preview/zombs/preview-2.png"
import zombsPreview3 from "@/assets/images/bootcamp/preview/zombs/preview-3.png"
import zombsPreview4 from "@/assets/images/bootcamp/preview/zombs/preview-4.png"
import zombsPreview5 from "@/assets/images/bootcamp/preview/zombs/preview-5.png"
import zombsPreview6 from "@/assets/images/bootcamp/preview/zombs/preview-6.png"
import zombsPreview7 from "@/assets/images/bootcamp/preview/zombs/preview-7.png"

import clixPreview1 from "@/assets/images/bootcamp/enroll/preview/clix/1.png"
import clixPreview2 from "@/assets/images/bootcamp/enroll/preview/clix/2.png"
import clixPreview3 from "@/assets/images/bootcamp/enroll/preview/clix/3.png"
import clixPreview4 from "@/assets/images/bootcamp/enroll/preview/clix/4.png"
import clixPreview5 from "@/assets/images/bootcamp/enroll/preview/clix/5.png"
import clixPreview6 from "@/assets/images/bootcamp/enroll/preview/clix/6.png"
import clixPreview7 from "@/assets/images/bootcamp/enroll/preview/clix/7.png"

import snip3downPreview1 from "@/assets/images/bootcamp/enroll/preview/snip3down/1.png"
import snip3downPreview2 from "@/assets/images/bootcamp/enroll/preview/snip3down/2.png"
import snip3downPreview3 from "@/assets/images/bootcamp/enroll/preview/snip3down/3.png"
import snip3downPreview4 from "@/assets/images/bootcamp/enroll/preview/snip3down/4.png"
import snip3downPreview5 from "@/assets/images/bootcamp/enroll/preview/snip3down/5.png"
import snip3downPreview6 from "@/assets/images/bootcamp/enroll/preview/snip3down/6.png"
import snip3downPreview7 from "@/assets/images/bootcamp/enroll/preview/snip3down/7.png"

import benjyfishyPreview1 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/1.png"
import benjyfishyPreview2 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/2.png"
import benjyfishyPreview3 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/3.png"
import benjyfishyPreview4 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/4.png"
import benjyfishyPreview5 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/5.png"
import benjyfishyPreview6 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/6.png"
import benjyfishyPreview7 from "@/assets/images/bootcamp/enroll/preview/benjyfishy/7.png"

import doubleliftPreview1 from "@/assets/images/bootcamp/enroll/preview/doublelift/1.png"
import doubleliftPreview2 from "@/assets/images/bootcamp/enroll/preview/doublelift/2.png"
import doubleliftPreview3 from "@/assets/images/bootcamp/enroll/preview/doublelift/3.png"
import doubleliftPreview4 from "@/assets/images/bootcamp/enroll/preview/doublelift/4.png"
import doubleliftPreview5 from "@/assets/images/bootcamp/enroll/preview/doublelift/5.png"
import doubleliftPreview6 from "@/assets/images/bootcamp/enroll/preview/doublelift/6.png"
import doubleliftPreview7 from "@/assets/images/bootcamp/enroll/preview/doublelift/7.png"

import penguPreview1 from "@/assets/images/bootcamp/enroll/preview/pengu/1.png"
import penguPreview2 from "@/assets/images/bootcamp/enroll/preview/pengu/2.png"
import penguPreview3 from "@/assets/images/bootcamp/enroll/preview/pengu/3.png"
import penguPreview4 from "@/assets/images/bootcamp/enroll/preview/pengu/4.png"
import penguPreview5 from "@/assets/images/bootcamp/enroll/preview/pengu/5.png"
import penguPreview6 from "@/assets/images/bootcamp/enroll/preview/pengu/6.png"
import penguPreview7 from "@/assets/images/bootcamp/enroll/preview/pengu/7.png"

import imperialHalCoachImage from "@/assets/images/bootcamp/coach/coach.jpg"
import zombsCoachImage from "@/assets/images/bootcamp/coach/zombs.png"
import clixCoachImage from "@/assets/images/bootcamp/enroll/coach/clix.png"
import snip3downCoachImage from "@/assets/images/bootcamp/coach/snip3down.png"
import benjyfishyCoachImage from "@/assets/images/bootcamp/enroll/coach/benjyfishy.png"
import doubleliftCoachImage from "@/assets/images/bootcamp/enroll/coach/doublelift.png"
import penguCoachImage from "@/assets/images/bootcamp/enroll/coach/pengu.png"

import imperialHalDiscordImage from "@/assets/images/bootcamp/discord/apex.png"
import imperialHalDiscordImageSm from "@/assets/images/bootcamp/discord/apex-small.png"
import imperialHalDiscordAvatar from "@/assets/images/icons/chat/hal_avatar.svg"
import zombsDiscordImage from "@/assets/images/bootcamp/discord/zombb.png"
import zombsDiscordAvatar from "@/assets/images/bootcamp/discord/zombsAvatar.png"
import clixDiscordImage from "@/assets/images/bootcamp/enroll/after-bootcamp/clix/discord/discord.png"
import clixDiscordCoachImage from "@/assets/images/bootcamp/enroll/after-bootcamp/clix/discord/coach.png"
import snip3downDiscordImage from "@/assets/images/bootcamp/discord/snip3down.png"
import snip3downDiscordAvatar from "@/assets/images/bootcamp/discord/snip3down-avatar.png"
import benjyfishyDiscordImage from "@/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/discord/discord.png"
import benjyfishyDiscordAvatar from "@/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/discord/avatar.png"

import doubleliftDiscordImage from "@/assets/images/bootcamp/enroll/after-bootcamp/doublelift/discord/discord.png"
import doubleliftDiscordCoachImage from "@/assets/images/bootcamp/enroll/after-bootcamp/doublelift/discord/coach.png"

import penguDiscordImage from "@/assets/images/bootcamp/enroll/after-bootcamp/pengu/discord/discord.png"
import penguDiscordCoachImage from "@/assets/images/bootcamp/enroll/after-bootcamp/pengu/discord/coach.png"

import imperialHalTrainingPlan1 from "@/assets/images/bootcamp/plans/plan1.png"
import imperialHalTrainingPlan2 from "@/assets/images/bootcamp/plans/plan2.png"
import imperialHalTrainingPlan3 from "@/assets/images/bootcamp/plans/plan3.png"
import zombsTrainingPlan1 from "@/assets/images/bootcamp/plans/zombs/plan1.png"
import zombsTrainingPlan2 from "@/assets/images/bootcamp/plans/zombs/plan2.png"
import zombsTrainingPlan3 from "@/assets/images/bootcamp/plans/zombs/plan3.png"
import clixPlan1 from "@/assets/images/bootcamp/enroll/after-bootcamp/clix/training-plan/plan1.png"
import clixPlan2 from "@/assets/images/bootcamp/enroll/after-bootcamp/clix/training-plan/plan2.png"
import clixPlan3 from "@/assets/images/bootcamp/enroll/after-bootcamp/clix/training-plan/plan3.png"
import snip3downPlan1 from "@/assets/images/bootcamp/plans/snip3down/1.png"
import snip3downPlan2 from "@/assets/images/bootcamp/plans/snip3down/2.png"
import snip3downPlan3 from "@/assets/images/bootcamp/plans/snip3down/3.png"
import benjyfishyPlan1 from "@/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/training-plan/plan1.png"
import benjyfishyPlan2 from "@/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/training-plan/plan2.png"
import benjyfishyPlan3 from "@/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/training-plan/plan3.png"
import doubleliftPlan1 from "@/assets/images/bootcamp/enroll/after-bootcamp/doublelift/training-plan/plan1.png"
import doubleliftPlan2 from "@/assets/images/bootcamp/enroll/after-bootcamp/doublelift/training-plan/plan2.png"
import doubleliftPlan3 from "@/assets/images/bootcamp/enroll/after-bootcamp/doublelift/training-plan/plan3.png"
import penguPlan1 from "@/assets/images/bootcamp/enroll/after-bootcamp/pengu/training-plan/plan1.png"
import penguPlan2 from "@/assets/images/bootcamp/enroll/after-bootcamp/pengu/training-plan/plan2.png"
import penguPlan3 from "@/assets/images/bootcamp/enroll/after-bootcamp/pengu/training-plan/plan3.png"

import trainingPlanIconUpload from "@/assets/images/icons/upload/upload-white.svg"
import trainingPlanIconLike from "@/assets/images/icons/like/like-white.svg"
import trainingPlanIconFile from "@/assets/images/icons/file/file-white.svg"

import imperialHalTwitchAvatar from "@/assets/images/bootcamp/twitch/streamer.png"
import imperialHalEmotes from "@/assets/images/bootcamp/twitch/emotes.png"
import imperialHalEmotesSm from "@/assets/images/bootcamp/twitch/emotes-small.png"

import zombsImageBenefit from "@/assets/images/bootcamp/image-benefit/zombs1.png"
import clixImageBenefit from "@/assets/images/bootcamp/enroll/after-bootcamp/clix/image-benefit/image-benefit.png"
import snip3downBenefit from "@/assets/images/bootcamp/image-benefit/snip3down.png"
import benjyfishyImageBenefit from "@/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/image-benefit/image-benefit.png"
import doubleliftImageBenefit from "@/assets/images/bootcamp/enroll/after-bootcamp/doublelift/image-benefit/image-benefit.png"
import penguImageBenefit from "@/assets/images/bootcamp/enroll/after-bootcamp/pengu/image-benefit/image-benefit.png"

export const BOOTCAMP_KEYS = {
  IMPERIAL_HAL: "imperial-hal",
  ZOMBS: "zombs",
  CLIX: "clix",
  SNIP3DOWN: "snip3down",
  BENJYFISHY: "benjyfishy",
  DOUBLELIFT: "doublelift",
  PENGU: "pengu",
}

/*
 * SEO META, not necessary
 */
const IMPERIALHAL_META = {
  title: "Mastering Competitive Apex Bootcamp with ImperialHal",
  description:
    "Become a better Apex Legends player in 30 days. ImperialHal is offering an immersive one-month bootcamp to drastically level up your in-game skills. He'll review your gameplay, host live Q&A sessions, and show you how to improve for every season of Apex to come.",
  keywords:
    "apex legends course, apex legends bootcamp, apex legends masterclass, imperialhal, get better at apex legends, win every fight in apex legends, rank up in apex legends, fastest way to learn apex legends, apex legends tips and tricks",
}

export const META_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_META,
}

/*
 * Partner data
 */
const ZOMBS_PARTNER = {
  name: "Zombs",
  nickname: "Zombs",
  pronouns: {
    subject: "he",
    object: "him",
    possessiveDeterminer: "his",
    possessive: "his",
    reflexive: "his",
  },
}

const CLIX_PARTNER = {
  name: "Clix",
  nickname: "Clix",
  pronouns: {
    subject: "he",
    object: "him",
    possessiveDeterminer: "his",
    possessive: "his",
    reflexive: "his",
  },
}

const SNIP3DOWN_PARTNER = {
  name: "Snip3down",
  nickname: "Snip3down",
  pronouns: {
    subject: "he",
    object: "him",
    possessiveDeterminer: "his",
    possessive: "his",
    reflexive: "his",
  },
}

const BENJYFISHY_PARTNER = {
  name: "benjyfishy",
  nickname: "benjyfishy",
  pronouns: {
    subject: "he",
    object: "him",
    possessiveDeterminer: "his",
    possessive: "his",
    reflexive: "his",
  },
}

const PENGU_PARTNER = {
  name: "Pengu",
  nickname: "Pengu",
  pronouns: {
    subject: "he",
    object: "him",
    possessiveDeterminer: "his",
    possessive: "his",
    reflexive: "his",
  },
}

export const PARTNER_DATA = {
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_PARTNER,
  [BOOTCAMP_KEYS.CLIX]: CLIX_PARTNER,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_PARTNER,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_PARTNER,
  [BOOTCAMP_KEYS.PENGU]: PENGU_PARTNER,
}

/*
 * Hero component data
 */
const IMPERIAL_HAL_HERO = {
  title: "Mastering Competitive Apex",
  videoId: "JnMJf8rZ",
  description:
    "Commit to 30 days of training with Imperial Hal, the most successful player in Apex Legends. During this 1 month class, learn to play, think, and lead like Hal. Finish the class with new leadership skills, access to Hal's private Discord server & Twitch perks, and a personalized training plan.",
  partner: "ImperialHal",
  landscape: null,
  enrollEndTime: "2021-09-21 17:00:00",
}

const ZOMBS_HERO = {
  title: "Climbing Valorant Ranked",
  videoId: "7FCYoDqA",
  description:
    "Unlock your true potential as a Valorant player in 14 days. Zombs is offering an immersive 2-week bootcamp to drastically level up your in-game skills. He'll review your gameplay, host live Q&A sessions, and show you how to improve for every act of Valorant to come.",
  partner: "Zombs",
  landscape: zombsHero,
  enrollEndTime: "2022-01-22 04:59:00",
}

const CLIX_HERO = {
  partner: "CLIX",
  title: "Mastering Fortnite Fighting",
  videoId: "cqmK3m5y",
  description:
    "In 14 days, unlock your mechanical potential in Fortnite. Competitive Fortnite superstar Clix is offering an immersive 2-week bootcamp to dramatically improve your fighting ability. He'll review your gameplay, host live Q&A sessions, and show you how to improve for every season of Fortnite to come. Leave the class with unforgettable experiences with Clix, newfound mechanical abilities, and pro-level decision making skills.",
  landscape: clixHero,
  enrollEndTime: "2022-02-18 07:59:59",
}

const SNIP3DOWN_HERO = {
  partner: "SNIP3DOWN",
  title: "Competitive Halo",
  videoId: "MP2RErqq",
  description:
    "In 14 days, learn what it takes to become the best in Competitive Halo. One of the most decorated players in Halo history is offering an immersive 2-week bootcamp to help you rapidly improve your abilities in competitive Halo. He'll review your gameplay, host live Q&A sessions, and teach you invaluable Halo techniques that you can use forever. You'll leave this class with new techniques, unforgettable experiences with Snip3down himself, and master your abilities in Halo.",
  landscape: snip3downHero,
  enrollEndTime: "2022-02-26 07:59:59", // in UTC
}

const BENJYFISHY_HERO = {
  partner: "benjyfishy",
  title: "Mastering Competitive Fortnite",
  videoId: "d8jbNQVh",
  description: "In just 14 days, you can learn everything you need to know about becoming a competitive Fortnite player. 12x Fortnite Cash Cup winner and World Cup finalist benjyfishy is running a 2-week boot camp to share the techniques he used to get to the top. He'll review your clips, host live Q&A sessions, and reveal secrets that only the top 1% of players know. You'll leave this class with new techniques, unforgettable memories from meeting benjyfishy, and drastically improve your abilities in Fortnite.",
  landscape: benjyfishyHero,
  enrollEndTime: "2022-04-28 06:59:59",
}

const DOUBLELIFT_HERO = {
  partner: "DOUBLELIFT",
  title: "Ranking up in League of Legends",
  videoId: "2Dd65cnH",
  description:
    "Doublelift, one of the most decorated League players with eight total LCS final wins and multiple World Championship appearances, is offering to share everything he knows about League. In his immersive two-week boot camp, Doublelift will help you take your game to the next level and unlock the results you've been searching for. He'll review your gameplay, host live Q&A sessions, and teach you key techniques that you've been missing out on while playing League.",
  landscape: doubleliftHero,
  enrollEndTime: "2022-03-29 07:59:59", // in UTC
}

const PENGU_HERO = {
  partner: "PENGU",
  title: "Mastering Ranked Rainbow Six",
  videoId: "3arDKKB9",
  description:
    "Pengu - the most accomplished Rainbow Six Siege player in history - is ready to spill his secrets and show you how he's mastered Siege. In 14 days, learn the ins-and-outs of the game from the mind of a 2-time Six Invitational and 4-time Pro League champion. You'll discover how to tailor the game to your exact playstyle and fasttrack your way up Siege's ranks. Pengu will review your gameplay, host live Q&A sessions, and give you vital insight that'll dramatically improve your skill set and abilities while playing Rainbow Six.",
  landscape: penguHero,
  enrollEndTime: "2022-04-17 07:59:59", // in UTC
}

export const HERO_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIAL_HAL_HERO,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_HERO,
  [BOOTCAMP_KEYS.CLIX]: CLIX_HERO,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_HERO,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_HERO,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_HERO,
  [BOOTCAMP_KEYS.PENGU]: PENGU_HERO,
}

/*
 * Meta info component data
 */
const IMPERIALHAL_INFO = [
  {
    label: "TIME",
    title: "1 Month of Pro Training",
    description: "30 days of immersive Apex training with ImperialHal.",
  },
  {
    label: "FINAL RESULT",
    title: "Play like a Top 1% Player",
    description:
      "By the end of the month, aim, move, and make decisions like Hal.",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "All Levels",
    description: "Beginner to advanced, level up from any skill level.",
  },
]

const ZOMBS_INFO = [
  {
    label: "TIME",
    title: "2 weeks of pro training",
    description: "14 days of immersive Valorant training with Zombs.",
  },
  {
    label: "FINAL PRODUCT",
    title: "Play like a top 1% player",
    description:
      "At the end of 2 weeks, aim, move, and make decisions like Zombs.",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "Beginner to Advanced",
    description: "Best suited for players between Iron and Immortal rankings.",
  },
]

const CLIX_INFO = [
  {
    label: "TIME",
    title: "2-Week Class",
    description:
      "14 days, structured to keep you motivated. 5-10 hrs/week for 2 weeks.",
  },
  {
    label: "FINAL PRODUCT",
    title: "Play like a top 1% player",
    description: "At the end of 2 weeks, aim, build, and think like Clix.",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "All Ages & Skill levels",
    description:
      "Improve your game rapidly, no matter your current skill level.",
  },
]

const SNIP3DOWN_INFO = [
  {
    label: "TIME",
    title: "2-Week Class",
    description: "14 days of immersive Halo training with Snip3down.",
  },
  {
    label: "FINAL PRODUCT",
    title: "Play like a top 1% player",
    description:
      "At the end of 2 weeks, shoot, move, and think like Snip3down.",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "All Ages & Skill levels",
    description:
      "Improve your game rapidly, no matter your current skill level.",
  },
]

const BENJYFISHY_INFO = [
  {
    label: "TIME",
    title: "2 weeks of pro training",
    description: "14-day structure, learning directly from benjyfishy. 5-10 hours/week for 2 weeks.",
  },
  {
    label: "FINAL PRODUCT",
    title: "Play like a top 1% player",
    description:
      "Rapidly Improve Your Competitive Fortnite Skills",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "All aspiring competitive players",
    description:
      "See measurable improvement in your gameplay, no matter your current abilities.",
  },
]

const DOUBLELIFT_INFO = [
  {
    label: "TIME",
    title: "2 weeks of pro training",
    description: "14 days of immersive League training with Doublelift.",
  },
  {
    label: "FINAL PRODUCT",
    title: "Play like a top 1% player",
    description:
      "At the end of two weeks, you'll move and think like Doublelift.",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "All Ages & Skill levels",
    description:
      "Improve your game rapidly, no matter your current skill level.",
  },
]

const PENGU_INFO = [
  {
    label: "TIME",
    title: "2 weeks of pro training",
    description: "14 days of immersive Siege training with Pengu.",
  },
  {
    label: "FINAL PRODUCT",
    title: "Play like a top 1% player",
    description:
      "At the end of two weeks, react, think and strike like Pengu.",
  },
  {
    label: "THIS CLASS IS FOR",
    title: "All Ages & Skill levels",
    description:
      "Improve your game rapidly, no matter your current rank or skill level.",
  },
]

export const INFO_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_INFO,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_INFO,
  [BOOTCAMP_KEYS.CLIX]: CLIX_INFO,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_INFO,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_INFO,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_INFO,
  [BOOTCAMP_KEYS.PENGU]: PENGU_INFO,
}

/*
 * Intro component data
 */
const IMPERIALHAL_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Learn to Play Like Hal in 30 Days",
  description: `X-Games & ALGS champion ImperialHal teaches you everything he knows
  about Apex Legends in this one-month bootcamp. Immerse yourself in
  never-before-seen footage where Hal breaks down his thought process with
  you, and describes his split second decision making across some of his
  best games. Learn how to think like Hal in 30 days.`,
  cards: [
    {
      image: card1,
      title: "Start to Finish Game Strategy",
      description:
        "ImperialHal walks you through first of its kind in-depth reviews of his own games from start to finish. In the class, he'll help you set goals and make the right Early, Mid, and Late game decisions.",
    },
    {
      image: card2,
      title: "Understand Your Role",
      description:
        "ImperialHal shares why it's so important to match your playstyle to your legend. He'll discuss the must-have roles for any squad, recommend legends, and help you understand your role within a team.",
    },
    {
      image: card3,
      title: "Plan Your Drop Spot",
      description:
        "Learn the in-depth preparation that goes into ImperialHal's East Fragment drop. He'll talk through how close to land with your teammates, creating a loot path, and identifying a plan B when you're contested. Put it all together and build detailed plans for your own drops.",
    },
    {
      image: card4,
      title: "Handle Third Parties",
      description:
        "ImperialHal explains which fights to take and how to finish them faster. Learn how armor swaps and creative decisions can increase your effective health pool to fend off would-be third parties.",
    },
    {
      image: card5,
      title: "Deal More Damage In Fights",
      description:
        "Aim isn't the only thing that matters when it comes to being effective in a fight. ImperialHal shows you how to find creative angles to peek from and control power positions that will help you get the edge over your opponent.",
    },
    {
      image: card6,
      title: "Maximize your inventory",
      description:
        "Every slot in your backpack is precious. ImperialHal will break down how to use your ammo, heals, throwables, and utility to their fullest potential. He'll also address common mistakes that players of all skill levels make when it comes to inventory  management.",
    },
    {
      image: card7,
      title: "Optimize your in-game settings",
      description:
        "ImperialHal walks you through each of his in-game settings and the importance behind his mouse/aim sensitivity, specific keybindings, and more. He'll also give his opinion on the pros and cons of mouse and keyboard vs. controller and how to adjust your play to fit your input.",
    },
    {
      image: card8,
      title: "Make decisions like ImperialHal",
      description:
        "Listen to Hal explain every minute detail of his thought process during amazing highlights, clutch situations, and tense tournament matches. By the end of the class, you'll recognize patterns from Hal's play that you can apply to your own games.",
    },
    {
      image: card9,
      title: "Perfect grenade placement",
      description:
        "Learn why grenades are one of the most underutilized tools by lower-level players and how much value they can bring to a fight. ImperialHal will show you the many creative uses for Arc Stars, Thermite Grenades, and Frag Grenades. By the end of this section, you'll be stocking your backpack full of them.",
    },
    {
      image: card10,
      title: "Learn Game Theory for Apex Legends",
      description:
        "What makes a great Battle Royale player? What skills make a great leader? ImperialHal answers these important questions and more across a wide range of in-game topics.",
    },
    {
      image: card11,
      title: "Record and analyze your gameplay",
      description:
        "Submit your own learning moments and highlights for ImperialHal to see and react to. Learn Hal's framework for reviewing gameplay and get feedback on your plays in our private Discord community.",
    },
    {
      image: card12,
      title: "Improve your Aim and Movement",
      description:
        "ImperialHal teaches you everything that goes into his incredible aim - from gun-specific recoil control, to bullet dropoff, flicking, tracking, acquiring targets quickly, and more. He'll also cover the essential movement techniques he uses in each game of Apex he plays.",
    },
    {
      image: card13,
      title: "Lead your team to victory",
      description:
        "Known as the best In-Game Leader in Apex Legends, ImperialHal shares his experience and knowledge from leading top competitive teams directly with you. Learn how to rotate, share resources, and set your team up to win.",
    },
    {
      image: card14,
      title: "High-level communication skills",
      description:
        "Listen in, as ImperialHal breaks down game-winning calls, high-level communication, and how he processes information. Even if you don't plan on being an in-game leader, learn what it takes to be a great teammate.",
    },
    {
      image: card15,
      title: "Stay calm under pressure",
      description:
        "In Apex Legends, anything can happen in an instant. The best players in the game make split second decisions without losing their cool. ImperialHal will talk you through chaotic situations and help you decide what to focus on.",
    },
    {
      image: card16,
      title: "Choosing your weapon loadout",
      description:
        "ImperialHal gives you his favorite weapon loadouts and explains the pros and cons of various weapon combinations. You'll be encouraged to step out of your comfort zone and have great games with loadouts you don't usually use.",
    },
    {
      image: card17,
      title: "Increase your game knowledge",
      description:
        "This class is a window into the world of Apex Legends as ImperialHal sees it. Over the course of 30 days, you'll gain access to tips, tricks, and strategies that only the best players in Apex know about. Start the class with an open mind and you'll leave a more experienced and confident player.",
    },
    {
      image: card18,
      title: "Connect with ImperialHal and a community of peers",
      description:
        "Interact and learn on your own time. Engage in live Q&A sessions with ImperialHal and find someone to train with in your close-knit peer group. Every moment across these 30 days will be spent as part of a community driven to learn and improve together.",
    },
  ],
}

const ZOMBS_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Learn to play like Zombs in 14 Days",
  description:
    "International Valorant Masters Champion Zombs teaches you everything he knows about Valorant in this two-week bootcamp. Immerse yourself in never-before-seen footage and content where Zombs breaks down his thought processes, techniques, and preparation across some of the biggest rounds of his career. Learn how Zombs hits Radiant ranking each act in 14 days.",
  cards: [
    {
      image: zombsCard1,
      title: "Start to finish round strategy",
      description:
        "Zombs walks you through first of its kind in-depth reviews from high-level ranked games and tournament matches from start to finish. In the class, he'll help you develop rounds and see the game from a completely new perspective.",
    },
    {
      image: zombsCard2,
      title: "Find your identity as a player",
      description:
        "Learn the critical roles and playstyles essential to any Valorant team and determine the best fit for you. Zombs will highlight his own unique playstyle to help you add new dimensions to your own.",
    },
    {
      image: zombsCard3,
      title: "Seize map control",
      description:
        "Put an end to seeing only what's in front of you. Learn to read enemy movements and process critical information to play the map like Zombs.",
    },
    {
      image: zombsCard4,
      title: "Bring more value to your team",
      description:
        "Become more confident in your gunfights and pull more weight alongside your teammates. Swing the odds in your favor and take control of every round.",
    },
    {
      image: zombsCard5,
      title: "Aim like the Pros",
      description:
        "Learn the advantages of high-level peeking techniques and crosshair placement that will win you more fights and keep you unpredictable.",
    },
    {
      image: zombsCard6,
      title: "Rank up to new heights",
      description:
        "Break through your ranked plateau, and take steps to achieve your dream rank through high level strategies and game theory taught by Zombs.",
    },
    {
      image: zombsCard7,
      title: "Learn High Level Communication",
      description:
        "Zombs will show you the importance of information; how to get it and what to do with it. Learn how top-ranked players communicate and plan rounds. Leave the bootcamp making callouts like a pro.",
    },
    {
      image: zombsCard8,
      title: "Make decisions like Zombs",
      description:
        "In every game of Valorant you're met with countless decisions to make. Become more confident in your ability to adapt, prioritize, and find the winning play.",
    },
    {
      image: zombsCard9,
      title: "Perfect your ability usage",
      description:
        "Ability usage is a key element that separates average players from the pros. Learn how to ascend your play through clever ability usage, and causing mayhem for your opponents.",
    },
    {
      image: zombsCard10,
      title: "Record and analyze your gameplay",
      description:
        "Submit your own clips and highlights for Zombs to see and react to. Learn how Zombs breaks down gameplay, and get direct access to live feedback in his private Discord server.",
    },
    {
      image: zombsCard11,
      title: "Win more clutches",
      description:
        "When pressure mounts, many players crumble. Learn how to hold your nerve and secure key round wins for your team.",
    },
    {
      image: zombsCard12,
      title: "Connect with Zombs and a community of peers",
      description:
        "Joining this bootcamp will give you direct access to Zombs and a tight-knit community who are all working towards the same goals. Interact with peers, play with others, and accelerate your learning.",
    },
  ],
}

const CLIX_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Learn to fight like Clix in 14 days",
  description:
    "5x World Cup Qualifier and King of Boxfights Clix teaches you everything he knows about fighting in Fortnite during this two-week bootcamp. Immerse yourself with never-before-seen footage and content where Clix breaks down his mechanics, building techniques, and decision making from top level competition. Master fighting like Clix in 14 days.",
  cards: [
    {
      image: clixCard1,
      title: "Optimize Your In Game Settings",
      description:
        "Clix walks you through Fortnite's most important in game settings including your mouse sensitivity, building keybinds and more. He'll also discuss the differences between controller vs. mouse and keyboard and how to play to the strengths of your input.",
    },
    {
      image: clixCard2,
      title: "Build Like Clix",
      description:
        "Learn what it takes to build at the highest level. Clix will break down common mistakes players of all levels make, and help you rapidly level up your building ability.",
    },
    {
      image: clixCard3,
      title: "Edit Faster",
      description:
        "Speed and efficiency make the difference between winning or losing a game of Fortnite. Clix will help you develop the editing techniques and speed that will leave your opponents wondering what just happened.",
    },
    {
      image: clixCard4,
      title: "Master Piece Control",
      description:
        "Piece control is one of the most crucial skills to help you win fights in Fortnite. Clix will show you step by step how he uses high level piece control to dominate opponents, secure refresh kills, and more.",
    },
    {
      image: clixCard5,
      title: "Level Up Your Aim",
      description:
        "Any great player needs to have superior aim in order to capitalize on the openings they create. Learn the ins and outs of perfect aim from Clix and start hitting more consistent shots.",
    },
    {
      image: clixCard6,
      title: "Conquer Creative",
      description:
        "Clix will show you what it takes to be a dominant force in creative. Enter every situation with a plan and stay steps ahead of your competition.",
    },
    {
      image: clixCard7,
      title: "Buildfighting Secrets",
      description:
        "Learn how Clix handles both high and low-ground situations, creates space for himself, and applies pressure to his opponents. Apply his advice to your own game and reap the rewards.",
    },
    {
      image: clixCard8,
      title: "Master Box Fighting",
      description:
        "Clix will show you his favorite box-fighting moves and how to perform them consistently. Learn his high-level reasoning behind split-second decisions and become a dominant force in Creative.",
    },
    {
      image: clixCard9,
      title: "Training Like The Best",
      description:
        "No player can reach greatness without the right plan and guidance. In this bootcamp, Clix will break down the roadmap of how he grinded to be the best and show you how to create your own custom training plan.",
    },
    {
      image: clixCard10,
      title: "Make Decisions Like Clix",
      description:
        "The most overlooked skill in Fortnite is your ability to adapt and think on your feet. Learn to come out on top by tapping into Clix's dense knowledge of Fortnite from years of competitive experience.",
    },
    {
      image: clixCard11,
      title: "Build Teamwork & Communication Skills",
      description:
        "Find others to play with and complete unique co-op challenges set by Clix. Improve your ability to carry your teammates and learn how to win in duos and trios.",
    },
    {
      image: clixCard12,
      title: "Connect with Clix and like minded peers",
      description:
        "Seize your chance to interact and learn from Clix himself. Engage with him during live Q&A sessions, find others to train with in his private discord server, and complete unique drills and challenges designed to help you apply what you've learned.",
    },
  ],
}

const SNIP3DOWN_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Master Competitive Halo in 14 days",
  description:
    "X-Games gold medalist, and Halo national champion Eric “Snip3down” Wrona teaches you everything he knows about competitive Halo Infinite during this two-week bootcamp. Immerse yourself with never-before-seen footage and lessons where Snip3down breaks down Halo mechanics, each competitive game mode, and high level decision making. Learn the ins and outs of Competitive Halo from the best in just 14 days.",
  cards: [
    {
      image: snip3downIntroCard1,
      title: "Optimize Your In Game Settings",
      description:
        "Halo Infinite's new settings can be overwhelming. Get an in depth breakdown to find your perfect settings, sensitivity, and configurations from Snip3down's own extensive testing.",
    },
    {
      image: snip3downIntroCard2,
      title: "Perfect Your Shot",
      description:
        "Steady and consistent aim is at the core of every great Halo player. Snip3down will show you his tips from 15 years of mastering the aiming style of Halo, and how you can implement it into your own gameplay to perfect your shot.",
    },
    {
      image: snip3downIntroCard3,
      title: "Secure Advantages for Your Team",
      description:
        "In Halo Infinite, power weapons and equipment dictate how the game is played at the highest level. Learn how to control objectives and rotate properly with your team to secure critical advantages on every map.",
    },
    {
      image: snip3downIntroCard4,
      title: "Increase Your Slaying Potential",
      description:
        "Known as one of the best slayers of all time, Snip3down will share everything you need to know in order to become the biggest problem for your opponents. This is your chance to learn insider secrets from one of the game's most seasoned pros.",
    },
    {
      image: snip3downIntroCard5,
      title: "Make Decisions Like Snip3down",
      description:
        "Learn from Snip3down's 15 years of competitive decision making to navigate any situation with a level head. Access never-before-seen reviews and in-depth analysis from Snip3down that will help you think just like him.",
    },
    {
      image: snip3downIntroCard6,
      title: "Abuse Grenades & Equipment",
      description:
        "To compete at the highest level, you need to level the playing field. Snip3down will show you the best weapon, grenade, and equipment combos that will optimize your time to kill like a professional player.",
    },
    {
      image: snip3downIntroCard7,
      title: "Game Mode Strategies",
      description:
        "Each competitive game mode in Halo requires its own unique approach. Snip3down will explain how he approaches Oddball, Slayer, Strongholds, and Capture the Flag while revealing the best strategies you can use to elevate your play in each mode.",
    },
    {
      image: snip3downIntroCard8,
      title: "The Power of Information",
      description:
        "Many players lack the awareness and processing ability to properly inform their choices. Whether it's a team callout, or reading an enemy's tendencies, every piece of information is valuable. Snip3down will show you how to exploit weaknesses and find advantages for your team.",
    },
    {
      image: snip3downIntroCard9,
      title: "Train Like A Pro",
      description:
        "No player can reach greatness without the right plan and guidance. In this bootcamp, Snip3down will show you his training techniques that made him the best and help set you on the right path.",
    },
    {
      image: snip3downIntroCard10,
      title: "Position Yourself to Win",
      description:
        "Snip3down believes the most overlooked but important skill for any Halo Player is their positioning. Snip3down will show you how to consistently put yourself in the right place, at the right time. ",
    },
    {
      image: snip3downIntroCard11,
      title: "Build Teamwork & Communication Skills",
      description:
        "Find others to play with and complete unique co-op challenges set by Snip3down. Elevate your ability to work with teammates, and learn how you can improve any team through teamwork and communication.",
    },
    {
      image: snip3downIntroCard12,
      title: "Connect with Snip3down",
      description:
        "Seize your chance to interact and learn from Snip3down himself. Engage with him during live Q&A sessions, find others to train with in his private discord server, and complete unique drills and challenges designed to help you apply what you've learned.",
    },
  ],
}

const BENJYFISHY_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Learn to fight like benjyfishy in 14 days",
  description: "Across the three years he's spent competing in Fortnite, benjyfishy has achieved things most players only dream of. From his experience winning 12x Cash Cups, taking 1st place in FNCS Solos Invitational, to playing at the World Cup in New York, he's done it all. And for a limited time, he's ready to share the same tactics he uses with YOU. This bootcamp will teach you the techniques you need to take your game to the next level, and you'll be learning directly from the Fortnite legend himself: benjyfishy.",
  cards: [
    {
      image: benjyfishyIntroCard1,
      title: "Train Like a Pro",
      description: "benjyfishy walks you through what it takes to become the best. Learn how to practice efficiently and improve faster than ever before.",
    },
    {
      image: benjyfishyIntroCard2,
      title: "Master Your Mechanics",
      description: "Learn what pro players do to master their mechanics. You'll level up your skills in piece control, editing, box fighting, build fighting and more!",
    },
    {
      image: benjyfishyIntroCard3,
      title: "Planning a Drop",
      description: "Where you decide to land sets the entire course for your game in competitive Fortnite. In this section, benjyfishy will break down how to plan a great drop and set yourself up for victory.",
    },
    {
      image: benjyfishyIntroCard4,
      title: "Taking Optimal Fights",
      description: "Most players think you should take any fight to get points in a tournament. benjyfishy will show you how wrong that is, and what fights you really ought to be taking.",
    },
    {
      image: benjyfishyIntroCard5,
      title: "Map Rotations",
      description: "The most difficult part of competitive Fortnite for most players is putting themselves in a position to get the most points out of a game. Learn how to navigate rotating through the early and mid game to maximize your points per game.",
    },
    {
      image: benjyfishyIntroCard6,
      title: "Securing Refreshes",
      description: "Materials and rotation tools should dictate every decision you make in competitive Fortnite. In this section, benjyfishy will teach you how to secure refresh kills and fuel yourself with the loot required to make it through the end game.",
    },
    {
      image: benjyfishyIntroCard7,
      title: "Surviving The Final Zones",
      description: "benjyfishy is commonly known as one of the most clutch endgame players. Learn how to navigate the hectic end game situations and end up taking home the win through benjyfishy's developed strategies.",
    },
    {
      image: benjyfishyIntroCard8,
      title: "Tournament Strategy",
      description: "Only pros truly understand how to approach every game in a tournament and play them appropriately. But now, it's your turn to learn how one of the best competitive players structures his tournament and plays each game.",
    },
    {
      image: benjyfishyIntroCard9,
      title: "Winning Mentality",
      description: "Half the battle in Fortnite is against yourself. Learn how to keep your cool, stop tilting in the earlier games of a tournament and exude confidence in every stage of a tournament.",
    },
    {
      image: benjyfishyIntroCard10,
      title: "Knowing Your Role",
      description: "Every player in a duo should bring a different skill set and provide different things in a game. In this section you'll learn all the roles, how to define your role and bring the most value to your duo.",
    },
    {
      image: benjyfishyIntroCard11,
      title: "Maximizing Placement",
      description: "Understanding how to take the most points out of a game is something that will level up your tournament performance instantly. Learn benjyfishy's strategies for maximizing placement, and taking the most points out of every game. ",
    },
    {
      image: benjyfishyIntroCard12,
      title: "Connect with benjyfishy",
      description: "Seize your chance to interact and learn from benjyfishy himself. Engage with him during live Q&A sessions, find others to train with in his private discord server, and complete unique drills and challenges designed to help you apply what you've learned.",
    },
  ],
}

const DOUBLELIFT_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Master Competitive League in 14 days",
  description: "The eight-time LCS Champion, multi-challenger veteran League of Legends player Peter “Doublelift” Peng teaches you the techniques you need to know to climb ranked in League of Legends. During this two-week bootcamp, you'll immerse yourself in never-before-seen footage while taking lessons where Doublelift breaks down League mechanics, start-to-finish game strategies, and high-level macro play. Learn the ins and outs of ranked League of Legends from the best in just 14 days, and commit to seeing results today.",
  cards: [
    {
      image: doubleliftIntroCard1,
      title: "Mechanical Secrets",
      description:
        "In League of Legends, no matter your role or play style, greatness requires top level mechanics. Learn how to become a flashy mechanical player just like Doublelift, and realize your true potential.",
    },
    {
      image: doubleliftIntroCard2,
      title: "Draft Analysis",
      description:
        "Most players just lock in a champion they excel with, and that's the end of it. But Doublelift will show you how to look at the champion select screen in a whole new light, and bring more value to your team in every single game.",
    },
    {
      image: doubleliftIntroCard3,
      title: "Level 1 Checklist",
      description:
        "Each game of League doesn't start when the minions spawn. It starts at 0:00. Learn how to approach the game as early as its opening seconds, and set yourself up for success with each new match.",
    },
    {
      image: doubleliftIntroCard4,
      title: "Resource Acquisition",
      description:
        "Gold is at the heart of everything you do in League. Doublelift will show you how to prioritize it and become stronger across every stage of the game. From early game to late game, you'll become a force to be reckoned with on the map.",
    },
    {
      image: doubleliftIntroCard5,
      title: "Wave Manipulation",
      description:
        "In low elo, wave management is something that's almost always undervalued. Learn how to look for advantages over your opponents and keep yourself ahead in XP for each stage of the game with Doublelift's powerful techniques.",
    },
    {
      image: doubleliftIntroCard6,
      title: "Vision Control",
      description:
        "Wards and vision tend to give most players difficulty, whether green players or experienced veterans. Learn new techniques straight out of Doublelift's personal playbook to stop dying from ganks and help your teammates through high level vision control.",
    },
    {
      image: doubleliftIntroCard7,
      title: "Lane Allocations",
      description:
        "Players tend to get confused on where they should be in the mid-game. Learn high-level macro play, and practice putting yourself in the right spot every single time using Doublelift's years of League experience as a guide.",
    },
    {
      image: doubleliftIntroCard8,
      title: "Objective Control",
      description:
        "In ranked play, both sides handle most objectives incorrectly. Learn how to guide your team through objectives and set up high-level vision to secure advantages around objectives while putting your team ahead through proactive communication.",
    },
    {
      image: doubleliftIntroCard9,
      title: "Teamfighting",
      description:
        "If you don't know how to position and prioritize targets in teamfights, you'll find yourself losing less difficult fights. Learn how to take down priority champions, kite enemy assassins, and play the teamfight according to your champion's strengths.",
    },
    {
      image: doubleliftIntroCard10,
      title: "Position Yourself to Win",
      description:
        "Doublelift believes the most overlooked skill for any League player is their positioning. Doublelift will show you how to ensure you're always in the right place at the right time while piloting your champion in the right positions.",
    },
    {
      image: doubleliftIntroCard11,
      title: "Build a Winning Mentality",
      description:
        "League can be a frustrating game. Learn Doublelift's personal techniques for keeping a winning mentality, and become the player you've always wanted to be.",
    },
    {
      image: doubleliftIntroCard12,
      title: "Connect with Doublelift",
      description:
        "Seize your chance to interact and learn from Doublelift himself. Engage with him during live Q&A sessions, find others to train with in his private Discord server, and complete unique drills and challenges designed to help you apply what you've learned.",
    },
  ],
}

const PENGU_INTROS = {
  subtitle: "AN IMMERSIVE TRAINING EXPERIENCE",
  title: "Master Competitive Siege in 14 days",
  description: "Niclas \"Pengu\" Mouritzen has won it all - Six Invitationals, Six Majors, Pro League Finals - all under bright lights and loads of pressure. In this immersive two-week class, he'll strip Siege back to its core fundamentals and take the pressure away so you can focus on becoming the best. You'll dive into never-before-seen footage and lessons as Pengu breaks down Siege tactics and strategies, the best operators for the job, and high-level decision making. Learn the ins-and-outs of Rainbow Six in just 14 days.",
  cards: [
    {
      image: penguIntroCard1,
      title: "Optimize Your In-Game Settings",
      description:
        "Pengu takes you through the heart of Siege's settings, detailing why his keybindings and configurations give him the competitive edge. Learn how to properly adjust your sensitivity, aspect ratio, HUD, crosshair, and more. You'll streamline your setup to maximize your movement & ensure you're in full control of the situation at all times.",
    },
    {
      image: penguIntroCard2,
      title: "Aim Train Like A Pro",
      description:
        "Incredible aim takes practice to master, and is crucial for every Siege player. Pengu will show you his tips to warm up properly, which aim trainers provide the most benefit, and how to put that practice to good use in-game.",
    },
    {
      image: penguIntroCard3,
      title: "Select the Best Operator For The Job",
      description:
        "Entry fragging, anchoring, roaming, supporting, lurking, flexing - no matter the role you play, there’s always an operator (or more than one!) who’s the best fit. Pengu will explain how to pick the operator that fulfills the right role, why it’s dangerous to only play an operator you excel with, and how multiple operators can do the same job to increase your win potential.",
    },
    {
      image: penguIntroCard4,
      title: "Operator Ban Analysis",
      description:
        "Some players see the Ban Phase as a joke. But Pengu will prove how you can disrupt your opponent's plans with the right operator bans, and give you a blueprint to follow when selecting ops for your team. He'll also talk about alternative operators you can use if what you want to play gets banned, and how to turn the match to your advantage before it even begins.",
    },
    {
      image: penguIntroCard5,
      title: "Drone Ahead and Plan Faster",
      description:
        "Drones are a vital utility that often gets overlooked in Ranked play. Learn about saving drones, flank drones, how they're used to help Entry players do their jobs, and more with Pengu's techniques and tricks.",
    },
    {
      image: penguIntroCard6,
      title: "Take Gunfights with Confidence",
      description:
        "Whether you're a ranked demon or a more passive player, you can turn the tide for your squad by aggressing at the right moment. Pengu teaches you how to increase your chances of winning gunfights, be smart as opposed to reckless, and use intel to your advantage to secure kills.",
    },
    {
      image: penguIntroCard7,
      title: "Position Yourself Appropriately ",
      description:
        "Hate getting killed in a spot you thought was safe? Pengu's wealth of experience will guide you to better default locations and give you a competitive edge when taking gunfights, including enemy proximity, timing, stances, and more.",
    },
    {
      image: penguIntroCard8,
      title: "Increase Your Map Knowledge",
      description:
        "Pengu's map knowledge as a pro is second-to-none. He'll help you understand where you're at at all times, and help you understand the many avenues of opportunity maps can afford attackers and defenders.",
    },
    {
      image: penguIntroCard9,
      title: "Crucial Decision Making",
      description:
        "Learn from Pengu's 6 years of competitive decision making to determine what steps need to be taken, with what resources and when, as a round progresses. Access never-before-seen reviews and analysis that will have you thinking just like Pengu does.",
    },
    {
      image: penguIntroCard10,
      title: "Build Teamwork & Communication Skills",
      description:
        "Pengu's professional teams have needed top-notch communication and leadership to excel. Learn from Pengu's experiences breaking down round-winning calls, processing intel, taking charge and working together with your teammates. Even if you're not the in-game leader type, knowing when to speak up is vital to winning.",
    },
    {
      image: penguIntroCard11,
      title: "Clutch Up and Win 1vXs",
      description:
        "The heat of battle can be daunting for lots of players. Pengu dives into Siege's clutch factor, helping you stay calm under pressure, make split-second decisions, and survive the chaos of Rainbow Six to emerge victorious.",
    },
    {
      image: penguIntroCard12,
      title: "Connect with Pengu & a community of peers",
      description:
        "Seize your chance to interact and learn from Pengu himself. Engage with him in live Q&A sessions, join his private Discord server to ask questions and find like-minded peers, and complete unique drills and challenges designed to amplify your Siege gameplay to the next level.",
    },
  ],
}

export const INTROS_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_INTROS,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_INTROS,
  [BOOTCAMP_KEYS.CLIX]: CLIX_INTROS,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_INTROS,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_INTROS,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_INTROS,
  [BOOTCAMP_KEYS.PENGU]: PENGU_INTROS,
}

/*
 * Preview component data
 */
const IMPERIALHAL_PREVIEW = {
  days: "30",
  title: "Step-by-step secret tricks from Hal",
  subtitle: "ONE MONTH. PERFECTLY STRUCTURED.",
  description: `Improve your strategy, leadership, and teamwork skills. Build upon the
      Apex core concepts with our world-class curriculum and unforgettable
      learning experience.`,
  parts: [
    {
      title: "Apex legends Core Concepts",
      description:
        "In part 1 of this 4-part bootcamp, ImperialHal discusses essential concepts every Apex player needs to know. He'll go in-depth, explaining how he thinks about the game and ways pros like him get the edge over their opponents. This section is all about leveling up your understanding of Apex legends from start to finish.",
      modules: [
        {
          image: preview1,
          title: "Choosing Your Legend",
          description:
            "ImperialHal explains what to think about when choosing your legend. He'll cover how to match your playstyle to your legend, must-haves for team compositions, and being creative with using your legend's abilities.",
        },
        {
          image: preview2,
          title: "Choosing a Drop Spot",
          description:
            "This module teaches you the importance of planning out your Drop Spot. You'll learn about loot paths, contingency plans if you're contested, and team rendezvous points. Study ImperialHal's East Fragment drop and use it to create a detailed plan of your own.",
        },
        {
          image: preview3,
          title: "Exercise #1 - Mapping out your drop spot",
          description:
            "In this first exercise, fully map out a comfortable and uncomfortable landing spot - making sure to map out your preferred loot path, team rendezvous points, and contingency plans in case you are contested. If you're an aggressive player, explore what it's like to take on a more slow-paced and methodical game. If you already like to take it slow, consider a high-activity area to push you out of your comfort zone.",
        },
        {
          image: preview4,
          title: "Weapon Loadouts",
          description:
            "Learn ImperialHal's favorite weapon loadouts as an IGL. He'll also discuss why it's important to be adaptable with the guns you're using and the best ways to play around common weapon combinations.",
        },
        {
          image: preview5,
          title: "Inventory Management",
          description:
            "ImperialHal covers how to optimally use your limited inventory slots. He'll talk about how much ammo and heals to carry, as well as the importance of  grenades, ultimate accelerants, heat shields, mobile respawn beacons, and more.",
        },
        {
          image: preview6,
          title: "Healing",
          description:
            "Learn what heals to use in which situations, the importance of armor-swapping for fending off 3rd parties, and how pros like ImperialHal maximize the amount of effective health they have in their fights.",
        },
        {
          image: preview7,
          title: "Q&A Session #1",
          description:
            "ImperialHal answers your questions live - 5pm PST in Discord",
        },
      ],
    },
    { title: "Mechanics" },
    { title: "Decision Making" },
    { title: "In-game Leadership" },
  ],
}

const ZOMBS_PREVIEW = {
  days: "14",
  title: "Step-by-step secret tricks from Zombs",
  subtitle: "2 Weeks. Perfectly Structured.",
  description:
    "Improve your map awareness, fighting techniques, and teamwork skills. Build upon your existing knowledge with our engaging curriculum and leave with an unforgettable experience.",
  parts: [
    {
      title: "Valorant Mechanics",
      description:
        "In part 1 of this 4-part bootcamp, Zombs discusses the core techniques that live at the heart of any tactical FPS. Learn the proper way to clear angles, take peeks, and learn mixups to keep your opponents guessing.",
      modules: [
        {
          image: zombsPreview1,
          title: "In-game settings",
          description:
            "Zombs covers his in-game settings, crosshair, mouse sensitivity, and more. Learn the advantages and disadvantages of different settings and use them to find your own.",
        },
        {
          image: zombsPreview2,
          title: "Aim Training",
          description:
            "Zombs gives you an inside look into his behind-the-scenes warmup routine - including open range exercises, aim training, and personalized tips that will help you become a more confident and consistent player.",
        },
        {
          image: zombsPreview3,
          title: "Challenge #1",
          description:
            "Benchmark your aiming skill against others in the bootcamp with Zombs' personal training program",
        },
        {
          image: zombsPreview4,
          title: "Peeking techniques",
          description:
            "Learn advanced tips and tricks that Zombs uses at the highest level of professional Valorant. Secure yourself free information, more favorable fights, and creative mixups.",
        },
        {
          image: zombsPreview5,
          title: "Positioning",
          description:
            "Become more intentional and creative with your positioning during every round of Valorant you play. By the end of this module, see your positioning on both attack and defense in a completely new light.",
        },
        {
          image: zombsPreview6,
          title: "Challenge #2 - Clip Submission",
          description:
            "Send Zombs a clip of a situation where your positioning got you killed. He'll select the best ones and review them during our first live Q&A session!",
        },
        {
          image: zombsPreview7,
          title: "Movement",
          description:
            "Zombs believes movement is one of the biggest untapped frontiers in the average player's skillset. Learn the nuances of walking, running, crouching, and what differentiates Zombs' movement from yours. ",
        },
      ],
    },
    { title: "Individual Playstyles" },
    { title: "Decision Making" },
    { title: "Ranked Strategy" },
  ],
}

const CLIX_PREVIEW = {
  days: "14",
  title: "Step-by-step secret tricks from Clix",
  subtitle: "2 Weeks of Rapid Improvement",
  description:
    "Improve your mechanics, fighting abilities, and competitive knowledge. Build up your Fortnite knowledge with our world-class curriculum and unforgettable learning experience.",
  parts: [
    {
      title: "Master Your Mechanics",
      description:
        "In part 1 of this 3-part bootcamp, Clix will show you the core mechanics that make up any great Fortnite player. Learn how Clix approaches building, editing, piece control and pick up tricks you can use to outplay your opponents.",
      modules: [
        {
          image: clixPreview1,
          title: "In-game settings",
          description:
            "Clix shows you his personal settings, sensitivity, build binds, and more. Learn why settings play such a key role in your abilities to perform before you even leave the battle bus.",
        },
        {
          image: clixPreview2,
          title: "Building",
          description:
            "Clix brings you into his world, breaking down his approach to becoming one of the best builders in the entire game. Including strategies to increase your building speed and transform your building techniques.",
        },
        {
          image: clixPreview3,
          title: "Editing",
          description:
            "Editing speed can be the difference between getting that impact kill, and missing out. Secure yourself more kills, and increase your editing speed with Clix.",
        },
        {
          image: clixPreview4,
          title: "Challenge #1",
          description:
            "Benchmark your editing speed against others in the bootcamp with Clix's personal training program",
        },
        {
          image: clixPreview5,
          title: "Piece Control",
          description:
            "All great Fortnite players will tell you that piece control in the current meta is the heart of any great player. Learn how to piece control your opponents and counter players trying to do the same to you.",
        },
        {
          image: clixPreview6,
          title: "Aim",
          description:
            "Clix believes aiming is the number one thing that Fortnite players underestimate. Learn how to improve your aim rapidly, and become a better player rapidly.",
        },
        {
          image: clixPreview7,
          title: "Challenge #2",
          description:
            "Send Clix a clip of a situation where you feel you made a mechanical mistake. He'll select the best ones and review them live, to show you what you should have done.",
        },
      ],
    },
    { title: "In Fight Training" },
    { title: "Decision Making" },
  ],
}

const SNIP3DOWN_PREVIEW = {
  days: "14",
  title: "Learn secret pro techniques from Snip3down",
  subtitle: "2 Weeks of Rapid Improvement",
  description:
    "Improve your mechanics, game mode strategies, and decision making. Expand your Halo knowledge with our world-class curriculum and unforgettable learning experience.",
  parts: [
    {
      title: "Fighting Mechanics",
      description:
        "In part 1 of this 3-part bootcamp, Snip3down will show you the core mechanics that make up any great Halo player. Learn how Snip3down approaches the sandbox, aim, movement, and putting it all together to outplay your opponents.",
      modules: [
        {
          image: snip3downPreview1,
          title: "In-game settings",
          description:
            "Snip3down shows you his personal button layouts, sensitivity, dead zones and more. Being in-tune with each of your settings will help you play at your best and stay comfortable in high-pressure situations.",
        },
        {
          image: snip3downPreview2,
          title: "Aim",
          description:
            "Snip3down brings you into his world, breaking down his approach to having one of the best shots in the game. Learn the techniques that top level Halo pros use to ensure they don't miss game winning shots.",
        },
        {
          image: snip3downPreview3,
          title: "Movement",
          description:
            "When aim isn't a factor, movement is what separates an average player from a pro. Learn how to utilize the movement in Halo to become more difficult to hit, and use your movement to make your shots easier to land.",
        },
        {
          image: snip3downPreview4,
          title: "Challenge #1",
          description:
            "Apply your learnings from Module #3 and test out Snip3down's favorite weapon combos with others in the Bootcamp.",
        },
        {
          image: snip3downPreview5,
          title: "Power Weapons & Equipment",
          description:
            "All great Halo players will tell you that power weapons are a massive factor in winning any game. One successful life with rockets can give your team a huge head start. Learn how to secure power weapons and powerful equipment from the best.",
        },
        {
          image: snip3downPreview6,
          title: "Putting it all together",
          description:
            "Halo is more than just your shot, movement, and what weapon you're using. In this section, he'll explain the \"Halo Dance\" and show you how to put all the mechanics together for the best result.",
        },
        {
          image: snip3downPreview7,
          title: "Challenge #2",
          description:
            "Send Snip3down a clip of a situation where you feel you made a big mechanical mistake that cost your team dearly. He'll select the best ones and review them live, to show you what you should have done.",
        },
      ],
    },
    { title: "Game Mode Strategies" },
    { title: "Decision Making" },
  ],
}

const BENJYFISHY_PREVIEW = {
  days: "14",
  title: "Step-by-step pro tricks from benjyfishy",
  subtitle: "2 Weeks of Rapid Improvement",
  description: "Improve your mechanics, competitive knowledge, and tournament strategy. Build up your Fortnite knowledge with our world-class curriculum and unforgettable learning experience.",
  parts: [
    {
      title: "Competitive Essentials",
    },
    {
      title: "Early & Mid Game",
    },
    {
      title: "Late Game Secrets",
      description: "In part 3 of this 4-part bootcamp, benjyfishy will show you the core techniques that make up a great competitive Fortnite player. Learn how benjyfishy approaches rotating, securing refreshes, and getting the most out of every game.",
      modules: [
        {
          image: benjyfishyPreview1,
          title: "Securing Refreshes",
          description: "benjyfishy shows you his personal strategy for securing refreshes, and more importantly the timing that you should be going for these refreshes.",
        },
        {
          image: benjyfishyPreview2,
          title: "Final Zone Rotations",
          description: "benjyfishy brings you into his world, breaking down his approach to rotating through the final zones of a competitive game.",
        },
        {
          image: benjyfishyPreview3,
          title: "Challenge #1",
          description: "Send benjyfishy a clip of yourself rotating through an end game, where you felt like you didn't know what to do. He'll review live and show you what he would have done.",
        },
        {
          image: benjyfishyPreview4,
          title: "Tarping",
          description: "How you utilize your materials in competitive Fortnite is very important. Learn how to save mats, tarp efficiently and tunnel your way through the endgame chaos.",
        },
        {
          image: benjyfishyPreview5,
          title: "Layer Selection",
          description: "benjyfishy is widely known as one of the best at choosing his layer. Learn his strategies and what you should look for when selecting your layer in Fortnite.",
        },
        {
          image: benjyfishyPreview6,
          title: "Challenge #2",
          description: "Send benjyfishy a clip of a situation where you feel you made a mechanical mistake. He'll select the best ones and review them live, to show you what you should have done.",
        },
        {
          image: benjyfishyPreview7,
          title: "Clutching and Mentality",
          description: "Having a good mentality is one of the keys to becoming a pro player. Take a journey into benjyfishy's world and he'll show you how to improve your mentality and clutch up in tense situations.",
        },
      ],
    },
    {
      title: "Tournament Strategy",
    },
  ],
  activePart: 2,
}

const DOUBLELIFT_PREVIEW = {
  days: "14",
  title: "Learn secret pro techniques from Doublelift",
  subtitle: "2 Weeks of Rapid Improvement",
  description:
    "Improve your mechanics, learn how to become a force in solo queue, and play the macro game like the pros. Expand your League knowledge with our world-class curriculum and unforgettable learning experience.",
  parts: [
    {
      title: "Early Game Advantages",
      description:
        "In part 2 of this 4-part bootcamp, Doublelift will show you the core concepts that pro players use to take the lead in the early game. You'll learn how to apply these to your game and quickly get ahead of your opponents.",
      modules: [
        {
          image: doubleliftPreview1,
          title: "Resource Acquisition",
          description:
            "Doublelift shows you how to acquire mythic items faster and put yourself in an overall stronger position.",
        },
        {
          image: doubleliftPreview2,
          title: "Wave Management",
          description:
            "Doublelift brings you into his world, breaking down his approach to using wave manipulation to earn advantages over your opponent.",
        },
        {
          image: doubleliftPreview3,
          title: "Strong & Weak Side",
          description:
            "In League, it's important to be self-aware of your lane's position.. Sometimes you'll have jungle resources, other times you'll need to play it safe. Learn how to identify these situations and play accordingly.",
        },
        {
          image: doubleliftPreview4,
          title: "Challenge #1",
          description:
            "Apply your learnings from Module #2 and try out what you've learned about wave management to find advantages. Complete the challenge in your assignment catalog.",
        },
        {
          image: doubleliftPreview5,
          title: "Vision Control",
          description:
            "All great League players will tell you how important vision is to avoid ganks, set up objectives, and help your team to be proactive. In this module you'll learn Doublelift's strategy behind vision, which allows him to earn advantages in every game.",
        },
        {
          image: doubleliftPreview6,
          title: "Challenge #2",
          description:
            "Send Doublelift a clip of a situation where you feel you made a big mechanical mistake that cost your team dearly. He'll select the best ones and review them live to show you what you should have done.",
        },
        {
          image: doubleliftPreview7,
          title: "Submit Your Gameplay",
          description:
            "To expedite your learning, send in your footage for Doublelift to review live in class. He'll go through and point out what you're doing correctly and what you could improve on. You'll learn how to approach situations you may previously have struggled with.",
        },
      ],
    },
    { title: "Pre-Game Concepts" },
    { title: "Mid & Late Game Strategies" },
    { title: "Individual Preparation" },
  ],
}

const PENGU_PREVIEW = {
  days: "14",
  title: "Step-by-step secrets, developed by Pengu, just for you",
  subtitle: "TWO WEEKS OF IMPROVEMENT",
  description:
    "Improve your mechanics, communication and game sense. Transform your understanding of Siege with our world-class curriculum and unforgettable learning experience.",
  parts: [
    {
      title: "Early Game Advantages",
      description:
        "In Part 1 of this 4-part bootcamp, Pengu will break down the essentials of Siege gameplay that will help you understand which aspect of the game you're best suited to. Explore your potential in this section as Pengu defines competitive roles, operator selection, taking gunfights, and putting everything together to come out on top.",
      modules: [
        {
          image: penguPreview1,
          title: "COMPETITIVE ROLES",
          description:
            "Pengu explains competitive roles, the differences between them, and how they fit into Siege theory. You'll learn about attacking and defending roles, and how to best fit your in-game actions to one of these main categories.",
        },
        {
          image: penguPreview2,
          title: "OPTIMAL POSITIONING",
          description:
            "Pengu jumps into the map, showing how the environment can be changed to suit your needs. You'll learn the importance of location, which is the proper stance, and how to maximize your proximity to allies & enemies to always be in the right place at the right time.",
        },
        {
          image: penguPreview3,
          title: "CHALLENGE #1",
          description:
            "Apply your learnings from Module 2 and test what you've learned about positioning to give yourself the edge in gunfights. Complete the challenge in your assignment catalog.",
        },
        {
          image: penguPreview4,
          title: "CHOOSING YOUR OPERATOR",
          description:
            "Pengu discusses characteristics of operators and which is the best pick for each specific job. You'll learn the operators best suited to your situation and playstyle, and how best to use their gadgets and utility.",
        },
        {
          image: penguPreview5,
          title: "READING THE SITUATION",
          description:
            "Pengu deep dives into critical Siege theory to help reveal advantages in your opponent's gameplan. This section covers intel, droning, timing, decision making, and much more to ensure your strategy is better than the enemy team's.",
        },
        {
          image: penguPreview6,
          title: "Q&A SESSION #1",
          description:
            "Get yourself ready to meet Pengu live in his first Q&A session where he'll be reviewing your clips, and interacting directly with members of the bootcamp.",
        },
        {
          image: penguPreview7,
          title: "Challenge #2",
          description:
            "Submit a clip of a situation that you felt completely overwhelmed, and Pengu will walk you through step by step how he would approach the situation.",
        },
      ],
    },
    { title: "Preparation & Execution" },
    { title: "Crafting Strategies" },
    { title: "Maximizing Your Impact" },
  ],
}

export const PREVIEW_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_PREVIEW,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_PREVIEW,
  [BOOTCAMP_KEYS.CLIX]: CLIX_PREVIEW,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_PREVIEW,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_PREVIEW,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_PREVIEW,
  [BOOTCAMP_KEYS.PENGU]: PENGU_PREVIEW,
}

/*
 * Coach component data
 */
const IMPERIALHAL_COACH = {
  name: "ImperialHal",
  description: `ImperialHal is the most successful Apex Legends player in the world.
  With top finishes in both X Games (ESPN) and the Apex Legends Global
  Series, he's established himself as a dominant mechanical player and
  in-Game Leader. Even amongst other pros, his creative playmaking, and
  intelligent shotcalling is legendary. On Twitch, he is the biggest Apex
  Legends streamer and personality, boasting over 1 million followers.`,
  image: imperialHalCoachImage,
  twitch: {
    url: "https://www.twitch.tv/tsm_imperialhal",
    copy: "1.1M Followers",
  },
}

const ZOMBS_COACH = {
  name: "Zombs",
  description:
    "Zombs is the highest earning and one of the most decorated professional Valorant players in the world. With a track record of first place finishes in nearly every major event, he's established himself as a dominant threat and anchor for the meteoric Sentinels roster. Known as the world's best Astra & Controller player, his crossmap awareness and calculated playstyle will help you reach new ranked heights.",
  image: zombsCoachImage,
  twitch: {
    url: "https://www.twitch.tv/zombs",
    copy: "286K FOLLOWERS",
  },
  youtube: {
    url: "https://www.youtube.com/ZOMBS",
    copy: "55k SUBSCRIBERS",
  },
}

const CLIX_COACH = {
  name: "CLIX",
  description:
    "Clix is one of the highest earning and most experienced professional Fortnite players in the world. As a 5-time World Cup qualifier, Clix has established himself as an adaptable threat in every competitive game mode. Known for his engaging content, creative thinking, and sharp mechanical skills, Clix will show you what it takes to become the best in Fortnite.",
  image: clixCoachImage,
  twitch: {
    url: "https://www.twitch.tv/clix",
    copy: "4.4M FOLLOWERS",
  },
  youtube: {
    url: "https://www.youtube.com/channel/UCym0XKpmoSl594oT9yhEk0Q",
    copy: "1.5M SUBSCRIBERS",
  },
}

const SNIP3DOWN_COACH = {
  name: "SNIP3DOWN",
  description:
    "Snip3down is one of the highest earning and most experienced professional Halo players in the world. As a tournament veteran, national Halo Champion and X-Games gold medalist, Snip3down has established himself as an adaptable threat in every Halo title. Having transitioned from his reputation as a mechanical slayer, to one of the smartest pros in the game, Snip3down will show you what it takes to become the best in competitive Halo.",
  image: snip3downCoachImage,
  twitch: {
    url: "https://www.twitch.tv/snip3down",
    copy: "555K FOLLOWERS",
  },
}

const BENJYFISHY_COACH = {
  name: "benjyfishy",
  description: "Across the  three years he's spent competing in Fortnite, benjyfishy has achieved things most players only dream of. From his experience winning 12x Cash Cup victories, taking 1st place in FNCS Solos Invitational, to playing at the World Cup in New York,  he's done it all. And for a limited time, he's ready to share the same tactics he uses with YOU. This bootcamp will teach you the techniques you need to take your game to the next level, and you'll be learning directly from the Fortnite legend himself: benjyfishy.",
  image: benjyfishyCoachImage,
  twitch: {
    url: "https://www.twitch.tv/benjyfishy",
    copy: "3.8M FOLLOWERS",
  },
  youtube: {
    url: "https://www.youtube.com/c/benjyfishy",
    copy: "1.7M SUBSCRIBERS",
  },
}

const DOUBLELIFT_COACH = {
  name: "DOUBLELIFT",
  description:
    "Doublelift is one of the highest-earning and most experienced professional League players in the world. As one of the most dominant pros in the LCS and an international world's representative for North America, Doublelift has established himself as one of the best to ever compete in the game. He's been a top player in every element of League, from mechanics to macro play, and he's ready to help you take your game to the next level.",
  image: doubleliftCoachImage,
  twitch: {
    url: "https://www.twitch.tv/doublelift",
    copy: "1.7m Followers",
  },
  youtube: {
    url: "https://www.youtube.com/c/doublelift",
    copy: "670k SUBSCRIBERS",
  },
}

const PENGU_COACH = {
  name: "PENGU",
  description:
    "Pengu is the most decorated Rainbow Six Siege player in the world. One of an elite group of individuals to win a Six Invitational, Six Major and Pro League final, his career speaks for itself as the most versatile and popular player that Siege has ever known. In an ever-changing Siege meta, Pengu stands out as hyper-intelligent, adaptable, and a deadly threat, no matter which position he plays. If anyone in Siege is suited to dive into the minutiae and help players improve through his wealth of experience, make no mistake - Pengu's the man for the job.",
  image: penguCoachImage,
  twitch: {
    url: "https://www.twitch.tv/pengu",
    copy: "1M followers",
  },
  youtube: {
    url: "https://www.youtube.com/c/BlouPenguin",
    copy: "612K subscribers",
  },
}

export const COACH_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_COACH,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_COACH,
  [BOOTCAMP_KEYS.CLIX]: CLIX_COACH,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_COACH,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_COACH,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_COACH,
  [BOOTCAMP_KEYS.PENGU]: PENGU_COACH,
}

/*
 * After bootcamp component data
 */
const IMPERIALHAL_AFTER_BOOTCAMP = {
  title: "What you get after 30 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  discord: {
    subtitle: "Join Hal's private Discord moderated by top 1% coaches",
    description: `Get feedback on your plays in Hal's private Discord & practice your
    moves with other students in the class.`,
    image: imperialHalDiscordImage,
    imageSm: imperialHalDiscordImageSm,
    question:
      "I feel like my team should have won this fight and the game. What could I have done differently?",
    coach: {
      name: "ImperialHal",
      avatar: imperialHalDiscordAvatar,
      message: `In solo ranked, you can only rely on yourself. I recommend
      practicing the flicking drills I created for you and to look for a
      friend in our Discord to practice 1v1 bubble fighting!`,
    },
  },
  trainingPlans: {
    subtitle: "Hal's review & personalized training plan",
    description: `Submit your clips directly to Hal for review & end the class with a
      personalized training plan.*`,
    plans: [
      {
        image: imperialHalTrainingPlan1,
        icon: trainingPlanIconUpload,
      },
      {
        image: imperialHalTrainingPlan2,
        icon: trainingPlanIconLike,
      },
      {
        image: imperialHalTrainingPlan3,
        icon: trainingPlanIconFile,
      },
    ],
  },
  twitch: {
    subtitle: "Get Twitch sub and emote to Hal's Twitch channel",
    description: `Hal will give all of his students a free subscription to his Twitch
    channel & limited-edition emotes.`,
    avatar: imperialHalTwitchAvatar,
    name: "TSM_ImperialHal",
    emotes: imperialHalEmotes,
    emotesSm: imperialHalEmotesSm,
  },
}

const ZOMBS_AFTER_BOOTCAMP = {
  title: "What you get after 14 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  imageBenefit: {
    subtitle:
      "Lifetime access to the class so you can revisit and learn for acts to come",
    description: "Learn on your own time and on your own schedule.",
    image: zombsImageBenefit,
  },
}

const CLIX_AFTER_BOOTCAMP = {
  title: "What you get after 14 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  imageBenefit: {
    subtitle:
      "Lifetime access to the class so you can revisit and learn for acts to come",
    description: "Learn on your own time and on your own schedule.",
    image: clixImageBenefit,
  },
}

const SNIP3DOWN_AFTER_BOOTCAMP = {
  title: "What you get after 14 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  imageBenefit: {
    subtitle:
      "Lifetime access to the class so you can revisit and learn for acts to come",
    description: "Learn on your own time and on your own schedule.",
    image: snip3downBenefit,
  },
}

const BENJYFISHY_AFTER_BOOTCAMP = {
  title: "What you get after 14 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  imageBenefit: {
    subtitle:
      "Lifetime access to the class so you can revisit and learn for seasons to come",
    description: "Learn on your own time, forever. When you're struggling, you can come back to the material.",
    image: benjyfishyImageBenefit,
  },
}

const DOUBLELIFT_AFTER_BOOTCAMP = {
  title: "What you get after 14 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  imageBenefit: {
    subtitle:
      "Lifetime access to the class so you can revisit and learn for acts to come",
    description: "Learn on your own time and on your own schedule.",
    image: doubleliftImageBenefit,
  },
}

const PENGU_AFTER_BOOTCAMP = {
  title: "What you get after 14 days",
  subtitle: "INNOVATIVE LEARNING EXPERIENCE",
  imageBenefit: {
    subtitle:
      "Lifetime access to the class so you can revisit and learn for acts to come",
    description: "Learn on your own time and on your own schedule.",
    image: penguImageBenefit,
  },
}

export const AFTER_BOOTCAMP_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_AFTER_BOOTCAMP,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_AFTER_BOOTCAMP,
  [BOOTCAMP_KEYS.CLIX]: CLIX_AFTER_BOOTCAMP,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_AFTER_BOOTCAMP,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_AFTER_BOOTCAMP,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_AFTER_BOOTCAMP,
  [BOOTCAMP_KEYS.PENGU]: PENGU_AFTER_BOOTCAMP,
}

/*
 * Benefits component data
 */
const IMPERIALHAL_BOOTCAMP_BENEFITS = {
  name: "ImperialHal",
  title: "Mastering Competitive Apex",
  benefits: [
    "Lifetime access to never-before-seen classes by Hal",
    "30 days of immersive Apex training with ImperialHal",
    "By the end of the month, master Aiming, Movement, and Decision-Making",
  ],
}

const ZOMBS_BOOTCAMP_BENEFITS = {
  name: "ZOMBS",
  title: "Climbing Valorant Ranked",
  benefits: [
    "14 days of immersive Valorant training with Zombs",
    "By the end of the bootcamp, master Aiming, Movement, and Decision-Making",
    "Lifetime access to never-before-seen classes by Zombs",
  ],
}

const CLIX_BOOTCAMP_BENEFITS = {
  name: "CLIX TEACHES",
  title: "Climbing Fortnite Ranked",
  benefits: [
    "14 days of immersive Fortnite training with Clix",
    "By the end of the bootcamp, master Aiming, Movement, and Decision-Making",
    "Lifetime access to never-before-seen classes by Clix",
  ],
}

const SNIP3DOWN_BOOTCAMP_BENEFITS = {
  name: "SNIP3DOWN TEACHES",
  title: "Competitive Halo",
  benefits: [
    "Snip3down Teaches Competitive Halo",
    "14 days of immersive Halo training with Snip3down",
    "By the end of the bootcamp, master Aim, Game Mode Strategies, and Decision-Making",
    "Lifetime access to never-before-seen classes by Snip3down",
  ],
}

const BENJYFISHY_BOOTCAMP_BENEFITS = {
  name: "BENJYFISHY TEACHES",
  title: "Mastering Competitive Fortnite",
  benefits: [
    "benjyfishy Teaches Mastering Competitive Fortnite",
    "14 days of immersive Fortnite training with benjyfishy",
    "By the end of this bootcamp, learn everything you need to Master Competitive Fortnite.",
    "Lifetime access to never-before-seen classes by benjyfishy",
  ],
}

const DOUBLELIFT_BOOTCAMP_BENEFITS = {
  name: "DOUBLELIFT TEACHES",
  title: "Ranking up in League of Legends",
  benefits: [
    "14 days of immersive League training with Doublelift",
    "By the end of the bootcamp, master start-to-finish game strategy, mechanics, macro play, and learn ranked secrets used by Doublelift himself.",
    "Lifetime access to never-before-seen classes by Doublelift",
  ],
}

const PENGU_BOOTCAMP_BENEFITS = {
  name: "PENGU TEACHES",
  title: "Mastering Ranked Rainbow Six",
  benefits: [
    "14 days of immersive Rainbow Six training with Pengu",
    "By the end of this bootcamp, learn everything you need to Master Competitive Rainbow Six",
    "Lifetime access to never-before-seen classes by Pengu",
  ],
}

export const BENEFITS_DATA = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: IMPERIALHAL_BOOTCAMP_BENEFITS,
  [BOOTCAMP_KEYS.ZOMBS]: ZOMBS_BOOTCAMP_BENEFITS,
  [BOOTCAMP_KEYS.CLIX]: CLIX_BOOTCAMP_BENEFITS,
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_BOOTCAMP_BENEFITS,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_BOOTCAMP_BENEFITS,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_BOOTCAMP_BENEFITS,
  [BOOTCAMP_KEYS.PENGU]: PENGU_BOOTCAMP_BENEFITS,
}

/*
 * Price data
 */
const SNIP3DOWN_PRICE = 279
const BENJYFISHY_PRICE = 199
const DOUBLELIFT_PRICE = 239
const PENGU_PRICE = 119

export const PRICE_DATA = {
  [BOOTCAMP_KEYS.SNIP3DOWN]: SNIP3DOWN_PRICE,
  [BOOTCAMP_KEYS.BENJYFISHY]: BENJYFISHY_PRICE,
  [BOOTCAMP_KEYS.DOUBLELIFT]: DOUBLELIFT_PRICE,
  [BOOTCAMP_KEYS.PENGU]: PENGU_PRICE,
}

/*
 * Template data
 */
const TEMPLATE_COMPONENTS = {
  INFO: infoComponent,
  HOW_IT_WORKS: howItWorksComponent,
  INTRO: introComponent,
  PREVIEW: previewComponent,
  COACH: coachComponent,
  AFTER_BOOTCAMP: afterBootcampComponent,
  OVERVIEW: overviewComponent,
  TESTIMONIALS: testimonialsComponent,
}

export const BOOTCAMP_TEMPLATES = {
  [BOOTCAMP_KEYS.IMPERIAL_HAL]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.OVERVIEW,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
  [BOOTCAMP_KEYS.ZOMBS]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
  [BOOTCAMP_KEYS.CLIX]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
  [BOOTCAMP_KEYS.SNIP3DOWN]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
  [BOOTCAMP_KEYS.BENJYFISHY]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
  [BOOTCAMP_KEYS.DOUBLELIFT]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
  [BOOTCAMP_KEYS.PENGU]: [
    TEMPLATE_COMPONENTS.INFO,
    TEMPLATE_COMPONENTS.INTRO,
    TEMPLATE_COMPONENTS.PREVIEW,
    TEMPLATE_COMPONENTS.COACH,
    TEMPLATE_COMPONENTS.AFTER_BOOTCAMP,
    TEMPLATE_COMPONENTS.TESTIMONIALS,
  ],
}



// WEBPACK FOOTER //
// ./src/store/bootcamp-enroll/bootcamp-enroll.constants.js